<template>
  <div class="vms-dropdown" :class="{ open: ddOpen }">
    <button class="vms-btn" @click="ddOpen = !ddOpen">
      <span class="vms-icon">{{ current.icon }}</span>
      <span class="vms-label">{{ current.label }}</span>
      <svg class="vms-caret" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>
    </button>
    <div v-if="ddOpen" class="vms-menu">
      <div
        v-for="opt in options"
        :key="opt.value"
        class="vms-opt"
        :class="{ active: opt.value === value }"
        @click="select(opt.value)"
      >
        <span class="vms-opt-icon">{{ opt.icon }}</span>
        <span class="vms-opt-label">{{ opt.label }}</span>
        <svg v-if="opt.value === value" class="vms-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
const OPTIONS = [
  { value: 'message', icon: '💬', label: 'Message Explorer' },
  { value: 'stage', icon: '🗂️', label: 'Stage Explorer' },
  { value: 'flow', icon: '🧭', label: 'Flow View' },
  { value: 'client', icon: '🎯', label: 'Client View' }
]

export default {
  name: 'view-mode-switcher',
  props: {
    value: { type: String, default: 'stage' }
  },
  data () {
    return {
      ddOpen: false,
      options: OPTIONS
    }
  },
  computed: {
    current () {
      return this.options.find(o => o.value === this.value) || this.options[0]
    }
  },
  mounted () {
    this.onDocClick = e => { if (!this.$el.contains(e.target)) this.ddOpen = false }
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onDocClick)
  },
  methods: {
    select (val) {
      this.ddOpen = false
      if (val !== this.value) this.$emit('change', val)
    }
  }
}
</script>

<style scoped>
.vms-dropdown{position:relative}
.vms-btn{
  display:flex;align-items:center;gap:8px;padding:6px 10px 6px 12px;
  background:var(--card);border:1px solid var(--card-border);border-radius:8px;
  cursor:pointer;font-family:inherit;color:var(--text);white-space:nowrap;
  transition:border-color .12s,box-shadow .12s;
}
.vms-btn:hover{border-color:var(--btn-hl-border)}
.vms-dropdown.open .vms-btn{border-color:var(--accent);box-shadow:0 0 0 3px rgba(59,130,246,0.12)}
.vms-icon{font-size:13px;line-height:1}
.vms-label{font-size:12.5px;font-weight:600}
.vms-caret{color:var(--text-muted);flex-shrink:0;transition:transform .15s}
.vms-dropdown.open .vms-caret{transform:rotate(180deg)}

.vms-menu{
  position:absolute;top:calc(100% + 6px);left:0;min-width:100%;
  background:var(--card);border:1px solid var(--card-border);border-radius:10px;
  box-shadow:0 12px 32px rgba(0,0,0,0.16);z-index:10;padding:6px;
}
.vms-opt{
  display:flex;align-items:center;gap:8px;padding:8px 10px;border-radius:7px;cursor:pointer;
  font-size:12.5px;color:var(--text);white-space:nowrap;
}
.vms-opt:hover{background:var(--card-label-bg)}
.vms-opt.active{background:rgba(59,130,246,0.1);color:var(--accent-light);font-weight:600}
.vms-opt-icon{font-size:13px;line-height:1}
.vms-opt-label{flex:1}
.vms-check{color:var(--accent);flex-shrink:0}
</style>



// WEBPACK FOOTER //
// ViewModeSwitcher.vue?a292fdee